// Google Map


var filtersSelected = [];
var mapOptions = null;
var mapMarkers = null;
var searchCache = {}
var mapObject = null;
var mapInfowindow = null;


window.currentMapZoom = null;
window.currentMapCenter = null;

var availablePlacesTypes = 
[
    {
        'title': 'Commerces et services',
        'titleEN': 'Shops and services',
        'value': 'store',
        'icon': '/utils/public/img/commerce.png',
        'content': [
            {
                'title': 'Boulangerie',
                'value': 'bakery'
            },
            {
                'title': "Banque",
                'value': 'bank'
            },
            {
                'title': "Station-essence",
                'value': 'gas_station'
            },
            {
                'title': "Centre commercial",
                'value': 'shopping_mall'
            },
            {
                'title': "Épicerie ou supermarché",
                'value': 'grocery_or_supermarket'
            }
        ],
    },
    {
        'title': 'Éducation',
        'titleEN': 'Schools',
        'value': '*',
        'icon': '/utils/public/img/education.png',
        'content': [
            {
                'title': 'École',
                'value': 'school'
            }
        ],
    },
    {
    	'title': 'Santé',
        'titleEN': 'Healthcare',
    	'value': 'health',
        'icon': '/utils/public/img/sante.png',
    	'content': [
            {
                'title': 'Médecins',
                'value': 'doctor'
            },
            {
                'title': 'Hôpitaux, cliniques',
                'value': 'hospital'
            },
            {
                'title': 'Pharmacies',
                'value': 'pharmacy'
            }
        ],
    },
    {
        'title': 'Services publics',
        'titleEN': 'Public services',
        'value': '*',
        'icon': '/utils/public/img/commerce.png',
        'content': [
            {
                'title': "Mairie",
                'value': 'city_hall'
            },
            {
                'title': "Poste",
                'value': 'post_office'
            }
        ]
    },
    {
        'title': 'Transports',
        'titleEN': 'Public transport',
        'value': '*',
        'icon': '/utils/public/img/transport.png',
        'iconByType': {
        	'airport' : '/utils/public/img/transportAvion.png',
        	'train_station': '/utils/public/img/transportTrain.png',
        	'taxi_stand': '/utils/public/img/taxis.png',
        	'bus_station': '/utils/public/img/bus.png'
        },
        'content': [   
            {
                'title': "Aéroport",
                'value': 'airport'
            },
            {
                'title': "Gare",
                'value': 'train_station'
            },
            {
            	'title': "Bus",
            	'value': "bus_station"
            },
            {
            	'title': "Taxi",
            	'value': "taxi_stand"
            }
        ]
    },
    {
        'title': 'Loisirs',
        'titleEN': 'Leisure activities',
        'value': '*',
        'icon': '/utils/public/img/loisirs.png',
        'content': [
            {
                'title': "Parc d'attractions",
                'value': 'amusement_park'
            },
            {
                'title': "Librairie",
                'value': 'library'
            },
            {
                'title': "Cinéma",
                'value': 'movie_theater'
            },
            {
                'title': "Parc",
                'value': 'park'
            }
        ]
    }
];

var iconCache = {};

var callbackNearbySeach = function(results,status,type,fromCache){
	if(!fromCache){
		if(!searchCache[type]){
			searchCache[type] = [];
		}
		
		searchCache[type].push({
			results: results,
			status: status,
		});
	}
	if(status===google.maps.places.PlacesServiceStatus.OK){
		for(var i = 0; i < results.length; i++){
			handlePlace(results[i]);
		}
	}else{
		if(fromCache){
			searchCache[type] = [];
		}else if(status != google.maps.places.PlacesServiceStatus.ZERO_RESULTS){
			console.error("Error in callbackNearbySeach, status : " + status);
		}
	}
};

var handlePlace = function(place){
	var placeLocation = place.geometry.location;
	var gpmarker    = getIconForPlace(place);
	var marker = new google.maps.Marker({
		map: mapObject,
		position: placeLocation,
		icon: gpmarker
	});

	if(!mapInfowindow){
		mapInfowindow = new google.maps.InfoWindow();
	}

	google.maps.event.addListener(marker,'click',function(){
		mapInfowindow.setContent(drawContent(place));
		mapInfowindow.open(mapObject,this);
	});
};

function getIconForPlace(place){
	var icon = place.icon;
	var trouve = false;
	var fini = false;
	var i = 0;

	//check if is already cached
	for(var c in place.types){
		placeType = place.types[c];
		if(iconCache[placeType]){
			icon = iconCache[placeType];
			trouve = true;
		}
	}

	while(!fini && !trouve){
		if(i < availablePlacesTypes.length){

			var availableIcon = availablePlacesTypes[i].icon;
			if(availableIcon){
				var availableTypes = availablePlacesTypes[i].content;
				for(var t in availableTypes){
					var currentType = availableTypes[t].value;
					for(var c in place.types){
						placeType = place.types[c];
						if(currentType == placeType){
							icon = availableIcon;
							trouve = true;
							iconCache[placeType] = icon;
						}
					}
				}
			}

			var iconByType = availablePlacesTypes[i].iconByType;
			if(iconByType){
				for(var customType in iconByType){
					var customIcon = iconByType[customType];
					var currentType = availableTypes[t].value;
					for(var c in place.types){
						placeType = place.types[c];
						if(customType == placeType){
							trouve = true;
							iconCache[placeType] = customIcon;
							icon = customIcon;
						}
					}
				}
			}
		}else{
			fini = true;
		}
		i++;
	}
	return new google.maps.MarkerImage(icon, null, null, null, new google.maps.Size(55, 70));
}

var drawContent = function(place){
	var content = $('<div></div>');
	if(place.photos && place.photos.length > 0){
		for(var p in place.photos){
			var photo = place.photos[p];

			if(typeof photo !== 'undefined'){
				var url = photo.getUrl({
					'maxWidth': 150,
					'maxHeight': 150
				});
				content.append('<center><img class="map-infowindow-img img-rounded" src="'+url+'" maxWidth="'+photo.width+'" maxHeight="'+photo.height+'"/></center>');
			}
		}
	}
	content.append('<h5 class="map-infowindow-title">'+place.name+"</h5>");
	content.append('<p class="map-infowindow-vicinity">'+place.vicinity+'</p>');

	return content.html();
};

function drawCheckbox(title,value){
	html = '<div class="checkbox aroundmap-checkbox-filter"><label>';
	html += '<input type="checkbox" name="'+value+'" class="aroundmap-checkbox-filter-input"/> ' + title;
	html += '</label></div>';
	return html;
}

function initMap(){
	options = mapOptions;
	options.radiusLevel = 10000;

	markers = mapMarkers;
	// Url d'icones pour les marqueurs.
	var pins = {
		default: '/utils/public/img/pin_map_noir.png',
		terrains: '/utils/public/img/pin_map_orange.png',
		programmes: '/utils/public/img/pin_map_bleu.png',
	};
	if(!window.currentMapZoom){
		window.currentMapZoom = options.zoom;
	}
	if(!window.currentMapCenter){
		window.currentMapCenter = options.center;
	}

	// On créé la map.
	mapObject = new google.maps.Map(document.getElementById(options.mapId), {
		zoom: window.currentMapZoom,
		center: window.currentMapCenter,
		disableDefaultUI: true,
		zoomControl: true,
		fullscreenControl: true,
		styles: [
		  {
		    "elementType": "geometry",
		    "stylers": [
		      {
		        "color": "#f1eee9"
		      }
		    ]
		  },
		  {
		    "elementType": "labels.icon",
		    "stylers": [
		      {
		        "visibility": "off"
		      }
		    ]
		  },
		  {
		    "elementType": "labels.text.fill",
		    "stylers": [
		      {
		        "color": "#181715"
		      }
		    ]
		  },
		  {
		    "elementType": "labels.text.stroke",
		    "stylers": [
		      {
		        "color": "#f9e5dc"
		      }
		    ]
		  },
		  {
		    "featureType": "administrative.land_parcel",
		    "elementType": "labels.text.fill",
		    "stylers": [
		      {
		        "color": "#181715"
		      }
		    ]
		  },
		  {
		    "featureType": "poi",
		    "elementType": "geometry",
		    "stylers": [
		      {
		        "color": "#eeeeee"
		      }
		    ]
		  },
		  {
		    "featureType": "poi",
		    "elementType": "labels.text.fill",
		    "stylers": [
		      {
		        "color": "#757575"
		      }
		    ]
		  },
		  {
		    "featureType": "poi.park",
		    "elementType": "geometry",
		    "stylers": [
		      {
		        "color": "#d5dcd3"
		      }
		    ]
		  },
		  {
		    "featureType": "poi.park",
		    "elementType": "labels.text.fill",
		    "stylers": [
		      {
		        "color": "#9e9e9e"
		      }
		    ]
		  },
		  {
		    "featureType": "road",
		    "elementType": "geometry",
		    "stylers": [
		      {
		        "color": "#ffffff"
		      }
		    ]
		  },
		  {
		    "featureType": "road.arterial",
		    "elementType": "labels.text.fill",
		    "stylers": [
		      {
		        "color": "#757575"
		      }
		    ]
		  },
		  {
		    "featureType": "road.highway",
		    "elementType": "geometry",
		    "stylers": [
		      {
		        "color": "#dadada"
		      }
		    ]
		  },
		  {
		    "featureType": "road.highway",
		    "elementType": "labels.text.fill",
		    "stylers": [
		      {
		        "color": "#616161"
		      }
		    ]
		  },
		  {
		    "featureType": "road.local",
		    "elementType": "labels.text.fill",
		    "stylers": [
		      {
		        "color": "#9e9e9e"
		      }
		    ]
		  },
		  {
		    "featureType": "transit.line",
		    "elementType": "geometry",
		    "stylers": [
		      {
		        "color": "#e5e5e5"
		      }
		    ]
		  },
		  {
		    "featureType": "transit.station",
		    "elementType": "geometry",
		    "stylers": [
		      {
		        "color": "#eeeeee"
		      }
		    ]
		  },
		  {
		    "featureType": "water",
		    "elementType": "geometry",
		    "stylers": [
		      {
		        "color": "#e2eef6"
		      }
		    ]
		  },
		  {
		    "featureType": "water",
		    "elementType": "labels.text.fill",
		    "stylers": [
		      {
		        "color": "#9e9e9e"
		      }
		    ]
		  }
		]
	});
	

	// Fenetre de la map.
	mapInfowindow = new google.maps.InfoWindow();

	// On insère les marqueurs.
	if( markers ) {
		for (var i = 0; i < markers.length; i++) {
		    var coord = markers[i].latLng;
		    var info = markers[i].info;
		    var marker = new google.maps.Marker({
			      position: coord,
			      map: mapObject,
			      icon: options.pin ? pins[options.pin] : pins.default,
			});


		    if(info) {
		    	google.maps.event.addListener(marker, 'click', (function(marker, i) {
					return function() {
						info = markers[i].info;
						var content = 
						'<div class="mini-card">' +
						'<img alt="'+ info.title +'" src="'+ info.media +'" width="250" height="auto"/>' +
						'<div class="title title-little">'+ info.title +'</div>' +
						'<div class="label">'+ info.label +'</div>' +
						'<div class="localisation">'+ info.localisation +'</div>';

						if(info.url) {
							content += '<a href="'+ info.url +'" title="Voir '+ info.title +' en détail">Voir le détail de ce bien</a>';
						}

						content += '</div>';

						mapInfowindow.setContent(content);
						mapInfowindow.open(mapObject, marker);
					}
				})(marker, i));
		    }
	  	}
	}

	//on affiche les resultats de recherche si définis
	if(filtersSelected && filtersSelected.length > 0){
		var service = new google.maps.places.PlacesService(mapObject);
		jQuery.each(filtersSelected,function(t,currentType){
			if(currentType !== undefined){
				if(searchCache[currentType]){
					for(var m in searchCache[currentType]){
						if(searchCache[currentType][m]){
							results = searchCache[currentType][m].results;
							status = searchCache[currentType][m].status;
							callbackNearbySeach(results,status,currentType,true);
						}
					}
				}else{
					for(var m in mapMarkers){
						var waitingTime = m * 1000 + 10;
						setTimeout(function(service,mapMarkers,m,mapOptions){
							var marker = mapMarkers[m];
							service.nearbySearch(
								{
									location: marker.latLng,
									radius: mapOptions.radiusLevel,
									types: [currentType]
								},
								function(results,status,pagination){
									if(status == google.maps.places.PlacesServiceStatus.OK){
										callbackNearbySeach(results,status,currentType);
										if(pagination && pagination.hasNextPage){
											setTimeout(function(pagination){
												pagination.nextPage();
											},2000,pagination);
										}
									}
								}
							);
						},waitingTime,service,mapMarkers,m,mapOptions);
						

					}
				}
			}
		});
	}

}
module.exports = function initializeGoogleMapCustomFn (options, markers) {
	mapOptions = options;
	mapMarkers = markers;

	initMap(options,markers);

	var filterContainerId = options.filtersId;
	// On affiche les filtres google places
	var container = $("#"+filterContainerId);

	var lang = $('html').attr('lang');
	var links = $('<ul class="map-filter-container list-inline no-deco"></ul>');
	var hiddencheckboxes = $('<div class="map-hidden-filters" style="display:none;"></div>');
	for(var i in availablePlacesTypes){
		var filtreGroup = availablePlacesTypes[i];
		var currentId = "filter_"+i;
		var title = filtreGroup.title;
		if(lang == 'en'){
			title = filtreGroup.titleEN;
		}
		var currentHeader = $('<li class="list-inline-item aroundmap-filter" data-target="'+currentId+'" ><span class="category-title">'+title+'</span></li>');
		links.append(currentHeader);
		var currentBody = $('<div id="'+currentId+'"></div>');
		for(var j in filtreGroup.content){
			var currentFilter = filtreGroup.content[j];
			currentBody.append(drawCheckbox(currentFilter.title,currentFilter.value));
		}
		hiddencheckboxes.append(currentBody);
	}

	// Need to call parallax here because of delage after inserting filters in DOM.
	setTimeout(function(){
		$('[data-parallax="scroll-custom"]').parallax({imageSrc: '/utils/public/img/footer4.jpg'});
	}, 2000);


	var content = $('<div></div>');
	content.append(links);
	content.append(hiddencheckboxes);
	container.append(content);

	//bind click events on checkbox
	$('.aroundmap-filter').on('click',function(){
		$(this).toggleClass('active');
		var $target = $("#"+$(this).data('target'));
		var checkeds = $(".aroundmap-checkbox-filter-input",$target);
		checkeds.each(function(){
			$(this).attr('checked',!$(this).attr('checked'));
		})
		filtersSelected = [];
		var checkeds = $(".aroundmap-checkbox-filter-input");
		for(var c in checkeds){
			current = checkeds[c];
			if(current.checked && current.name !== undefined){
				filtersSelected.push(current.name);
			}
		}
		window.currentMapZoom = mapObject.getZoom();

		var center = mapObject.getCenter();
		window.currentMapCenter = {
			lat: center.lat(),
			lng: center.lng()
		};
		initMap();
		
	});

}